import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { adminArrearsReportMonthly } from "../../api";
import ReportTablePage from "../../components/admin/ReportTablePage";

function monthStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export default function ReportArrearsMonthly() {
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState("perumahan");
  const [dateValue, setDateValue] = useState(monthStr());
  const [search, setSearch] = useState("");
  const [summary, setSummary] = useState({});
  const [kawasanSummary, setKawasanSummary] = useState([]);
  const [items, setItems] = useState([]);

  const load = async () => {
    try {
      setLoading(true);
      const res = await adminArrearsReportMonthly({ template, month: dateValue });
      setSummary(res.summary || {});
      setKawasanSummary(res.kawasan_summary || []);
      setItems(res.items || []);
    } catch (e) {
      await Swal.fire({ icon: "error", title: "Gagal", text: e?.response?.data?.error || "Gagal load laporan tunggakan bulanan." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [template, dateValue]);

  return (
    <ReportTablePage
      title="Laporan Tunggakan Bulanan"
      subtitle="Snapshot tunggakan semasa; bulan ialah rujukan paparan."
      loading={loading}
      template={template}
      setTemplate={setTemplate}
      dateMode="month"
      dateValue={dateValue}
      setDateValue={setDateValue}
      search={search}
      setSearch={setSearch}
      summary={summary}
      kawasanSummary={kawasanSummary}
      items={items}
      onRefresh={load}
      itemColumns={[
        { key: "no_akaun", label: "No Akaun" },
        { key: "nombor_unit", label: "Unit" },
        { key: "kawasan", label: "Kawasan" },
        { key: "amount", label: "Tunggakan Semasa (RM)", render: (v) => Number(v || 0).toFixed(2) },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
